module.exports = {"id":"145889","name":"Tito","rating":"73","photo":"./data/images/photos/3/145889.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["DD","DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Tito0.json
// module id = 4152
// module chunks = 0